import type { TOC } from '@ember/component/template-only';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelRevpakExportsController from 'lumen/controllers/hotel/revpak-exports';
import getEnv from 'lumen/helpers/get-env';

interface HotelRevpakExportsSignature {
  Args: {
    controller: HotelRevpakExportsController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-hotel-revpak-exports"
    @query={{@controller.iframeQPs}}
    @url="/revpak/exports"
  />
</template> satisfies TOC<HotelRevpakExportsSignature>;
